import { useIntl } from "react-intl";
import { PageTitle } from "src/_metronic/layout/core";
import { AfterAndBeforeImageGridContainer } from "src/app/containers";

const ReviewImages = () => {
    const { formatMessage } = useIntl();
    return (
        <>
            <PageTitle>{formatMessage({ id: "reviewed.title" })}</PageTitle>
            <AfterAndBeforeImageGridContainer />
        </>
    );
};

export default ReviewImages;
